
import VueRendererComponent from "client/src/renderers/vue-components/vue-renderer-component.vue";
import "smart-webcomponents/source/modules/smart.dockinglayout.js";

window.Smart.License = "8414516F-15A2-4D84-A7AF-A9A72400DB02";

export default {
  name: "layout",
  mixins: [VueRendererComponent],
  data() {
    return {
      actions: null,
      docking: null,
      layout: null,
      options: null,
      layoutId:  _.uniqueId('lw')
    }
  },
  methods: {
    parseLayout(layout) {
      let result = _.cloneDeep(layout);
      const iterate = (obj) => {
        Object.keys(obj).forEach(key => {

          if (key === 'items') {
            obj.items = _.map(obj.items, (value, key) => {
              _.set(value, 'id', key);
              return value;
            });
          }

          if (_.isObject(obj[key]) && !_.isNil(obj[key])) {
              iterate(obj[key])
          }
        })

        const area = _.get(obj, 'area')

        if (area && !document.getElementById(area)) {
          const div = this.createWrapper(area)
          obj.content = div;
        }
      }

      iterate(result);
      result = _.map(result);

      return result;
    },
    actionUpdateTab(action) {
      const panels = this.docking.items;
      const panel = _.filter(panels, (panel) => {
        return panel.getAttribute('id') == action.element;
      })
      if (!panel[0]) {
        return;
      }
      let triggerType;
      _.map(action.data.tabs, (value, key) => {
        const tab = this.docking.querySelector(`smart-tab-item[id=${key}]`)
        const data = _.cloneDeep(value);
        data.id = key;
        if (!tab) {
          // CREATE TAB
          // prepare content
          if (!_.isNil(data.area)) {
            // The wrapper must carry the *area* id, not the tab id: ViewManager
            // looks areas up as `#{area}[role="view-area"]`.
            this.releaseArea(data.area);
            const div = this.createWrapper(data.area)
            data.content = div;
          }

          // insert tab
          panel[0].$tabsElement.element.insert(999, data);
          // set new tabs id
          const tabs = panel[0].$tabsElement.element.getTabs();
          _.map(tabs, (tab) => {
            if (tab.getAttribute('label') === data.label) {
              tab.setAttribute('id', data.id);
              // new tabs are closeable unless explicitly opted out
              this.applyTabCloseable(tab, _.get(data, 'closeable', true));
            }
          })
          // select last added tab
          if (data.selected) {
            panel[0].select(999);
          }
          triggerType = 'tabCreated';
        } else {
          // UPDATE TAB
          const tabsContainer = tab.closest("smart-tabs");
          const tabs = tabsContainer.getTabs();
          _.map(tabs, (tab) => {
            if (tab.getAttribute('id') === data.id) {
              const index = tab.getAttribute('index');
              tabsContainer.update(index, data.label);
              if (_.has(data, 'content')) {
                this.setTabContent(tab, data.content);
              }
              if (_.has(data, 'closeable')) {
                this.applyTabCloseable(tab, !!data.closeable);
              }
              if (data.selected) {
                tabsContainer.select(index);
              }
            }
          })
          triggerType = 'tabUpdated';
        }

        this.updateLayout({
          type: 'updateTab',
          id: key,
          panel: action.element,
          value,
        });

        this.trigger({
          type: triggerType,
          data: {
            panel: action.element,
            value
          }
        });
      });
    },
    isTabCloseable(tab) {
      return tab.getAttribute('closeable') !== 'false';
    },
    applyTabCloseable(tab, closeable) {
      // smart-docking-layout does not forward per-item flags from the layout
      // JSON, so mirror it onto the tab item ourselves. closeButtonHidden only
      // hides the button; the 'closeable' attribute is what guards the actual
      // close paths (middle click, drag-out, trigger).
      tab.setAttribute('closeable', closeable ? 'true' : 'false');
      tab.closeButtonHidden = !closeable;
    },
    applyLayoutCloseable() {
      const flags = {};
      const iterate = (obj) => {
        Object.keys(obj).forEach(key => {
          const item = obj[key];
          if (_.isObject(item) && !_.isNil(item)) {
            if (_.has(item, 'closeable')) {
              flags[key] = !!item.closeable;
            }
            iterate(item);
          }
        })
      }

      iterate(this.layout);

      _.forEach(flags, (closeable, id) => {
        const tab = this.docking.querySelector(`smart-tab-item[id=${id}]`);
        if (tab) {
          this.applyTabCloseable(tab, closeable);
        }
      })
    },
    setTabContent(tab, content) {
      // The view area wrapper must survive: smart-ui's applyContent() calls
      // clearContent() on '' / null, which would drop the wrapper div (and its
      // MutationObserver) and leave nothing for Graphileon to render into.
      const wrapper = tab.querySelector('[role="view-area"]');

      if (_.isNil(content) || content === '') {
        if (wrapper) {
          wrapper.innerHTML = '';
          return;
        }
        tab.content = '';
        return;
      }

      if (content instanceof HTMLElement) {
        if (wrapper) {
          wrapper.innerHTML = '';
          wrapper.appendChild(content);
          return;
        }
        tab.content = content;
        return;
      }

      if (wrapper) {
        wrapper.innerHTML = content;
        return;
      }
      tab.content = content;
    },
    actionCloseTab(action) {
      const panels = this.docking.items;
      const panel = _.filter(panels, (panel) => {
        return panel.getAttribute('id') == action.element;
      })
      if (!panel[0]) {
        return;
      }

      // accept {tabs: {id: {...}}}, {tabs: [id, ...]} or {tab: id}
      const tabs = _.get(action, 'data.tabs');
      let ids;
      if (_.isArray(tabs)) {
        ids = _.map(tabs, (value) => _.isObject(value) ? _.get(value, 'id') : value);
      } else if (_.isObject(tabs)) {
        ids = _.keys(tabs);
      } else {
        ids = _.compact([_.get(action, 'data.tab'), _.get(action, 'data.id')]);
      }

      _.map(_.compact(ids), (id) => {
        const tab = this.docking.querySelector(`smart-tab-item[id=${id}]`);
        if (!tab || !this.isTabCloseable(tab)) {
          return;
        }

        const tabsContainer = tab.closest("smart-tabs");
        if (!tabsContainer) {
          return;
        }

        const closedIndex = this.getTabIndex(tabsContainer, id);
        if (_.isNil(closedIndex)) {
          return;
        }
        const selectedIndex = this.getSelectedTabIndex(tabsContainer);

        // smart-tabs removes the tab itself before firing 'close'; mirror that here
        tabsContainer.removeAt(closedIndex);

        this.handleTabClosed(tabsContainer, closedIndex, id, selectedIndex);
      });
    },
    getTabIndex(tabsContainer, id) {
      const tabs = tabsContainer.getTabs();
      let result;
      _.forEach(tabs, (tab, index) => {
        if (tab.getAttribute('id') === id) {
          result = _.isNil(tab.index) ? index : tab.index;
          return false;
        }
      })

      return result;
    },
    getSelectedTabIndex(tabsContainer) {
      const tabs = tabsContainer.getTabs();
      let result;
      _.forEach(tabs, (tab, index) => {
        if (tab.hasAttribute('selected')) {
          result = _.isNil(tab.index) ? index : tab.index;
          return false;
        }
      })

      return result;
    },
    handleTabClosed(tabContainer, closedIndex, id, currentSelectedIndex) {
      let indexToBeSelected;

      const removedItem = this.updateLayout({type: 'removeTab', id});
      const panel = tabContainer.closest("smart-tabs-window")
      const panelID = panel.getAttribute('id');

      // Drop the wrapper so the area id is free when the tab is reopened.
      this.releaseArea(_.get(removedItem, 'area'));

      let triggerTabSelected;
      if (currentSelectedIndex == closedIndex) {
        indexToBeSelected = closedIndex == 0 ? 0 : closedIndex - 1;
        triggerTabSelected = true;
      } else if (currentSelectedIndex > closedIndex) {
        indexToBeSelected = currentSelectedIndex - 1;
        triggerTabSelected = false;
      } else {
        indexToBeSelected = currentSelectedIndex;
        triggerTabSelected = false;
      }

      this.trigger({
        type: 'tabClosed',
        data: {
          panel: panelID,
          value: removedItem
        }
      });

      const isLastTab = tabContainer.getTabs().length === 0;

      if (isLastTab) {
        this.trigger({
          type: 'lastTabClosed',
          data: {
            panel: panelID,
            value: removedItem
          }
        });
      }

      if (!isLastTab) {
        panel.select(indexToBeSelected);
        if (triggerTabSelected) {
          this.triggerTabSelected(tabContainer, indexToBeSelected)
        }
      }
    },
    updateLayout(data) {
      const update = (layout, updateType) => {
        let result;
        const iterate = (obj) => {
          Object.keys(obj).forEach(key => {
  
            if (updateType === 'updateTab') {
              if (key === data.panel) {
                const final = _.merge(obj[key].items[data.id], data.value)
                _.set(obj[key].items, data.id, final)
                result = final;
              }
            }

            if (updateType === 'removeTab') {
              if (key === data.id) {
                result = obj[key];
                _.unset(obj, data.id)
              }
            }
  
            if (_.isObject(obj[key]) && !_.isNil(obj[key])) {
                iterate(obj[key])
            }
          })
        }

        iterate(layout);
        return result;
      }
      
      const result = update(this.layout, data.type)
      this.requestUpdate({layout: this.layout});

      return result;
    },
    triggerTabSelected(tabContainer, index) {
      const tabs = tabContainer.getTabs();
      const tab = tabs[index];
      const id = tab.getAttribute('id');
      const panel = tabContainer.closest("smart-tabs-window").getAttribute('id');

      const getSelectedItem = (id) => {
        let result;
        const iterate = (obj) => {
          Object.keys(obj).forEach(key => {

            if (key === id) {
              result = obj[key];
            }

            if (_.isObject(obj[key]) && !_.isNil(obj[key])) {
                iterate(obj[key])
            }
          })
        }

        iterate(this.layout);
        return result;
      }


      const selectedItem = getSelectedItem(id);
      if (selectedItem) {
        this.trigger({
          type: 'tabSelected',
          data: {
            panel,
            value: selectedItem
          }
        });
      }
    },
    releaseArea(area) {
      // A stale wrapper left over from a previous tab would shadow the new one:
      // ViewManager resolves areas by id, and getElementById returns the first
      // match in document order.
      if (_.isNil(area)) {
        return;
      }

      const stale = document.getElementById(area);
      if (stale && stale.getAttribute('role') === 'view-area') {
        stale.remove();
      }
    },
    createWrapper(id) {
      let div = document.createElement('div');
      div.classList.add("smart-graphileon-container-wrapper")
      div.setAttribute("id", id);
      div.setAttribute("role", "view-area")
      this.resizeContent(div);

      return div;
    },
    resizeContent(div) {
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList") {
            const graphileonContainer = div.getElementsByClassName("graphileon-container");
            if (graphileonContainer[0]) {
              const height = _.get(graphileonContainer[0].style, 'height');
              const width = _.get(graphileonContainer[0].style, 'width');
              
              if (!height && height !== 'inherit') {
                graphileonContainer[0].style.height = 'inherit';
              }
              if (!width && width !== 'inherit') {
                graphileonContainer[0].style.width = 'inherit';
              }
            }
          }
        }
      }

      const observer = new MutationObserver(callback);
      observer.observe(div, {childList: true});
    },
    applyDefaults() {
      this.docking.animation = 'none';
      this.docking.style.overflow = 'hidden';
    },
    applyOptions() {
      if (!this.options) {
        return;
      }

      if (this.options.hideSplitterBars) {
        this.docking.hideSplitterBars = true;
      }

      if (this.options.hideLayoutBorder) {
        this.docking.style.border = 'none';
      }

      if (this.options.hideTabBorders) {
        const windows = this.docking.querySelectorAll('smart-tabs-window');
        _.forEach(windows, (window) => {
          window.style.border = 'none';
        })
      }

    }
  },
  watch: {
    'actions': {
      deep: true,
      handler: function (actions) {
        if (_.isNil(actions)) {
          return;
        }

        _.map(actions, (action) => {
          if (action.type === 'update') {
            this.actionUpdateTab(action);
          }
          if (action.type === 'close') {
            this.actionCloseTab(action);
          }
        })

        this.requestUpdate({actions: null})
      }
    }
  },
  mounted() {
    const docking = document.querySelector(`smart-docking-layout[layoutId=${this.layoutId}]`);
    this.docking = docking;
    const parsedLayout = this.parseLayout(this.layout);
    this.docking.layout = parsedLayout;

    this.applyDefaults();
    this.applyOptions();
    this.applyLayoutCloseable();

    const tabContainers = this.docking.querySelectorAll("smart-tabs");
    let closingTabs;
    let currentSelectedIndex;

    _.map(tabContainers, (tabContainer) => {
      tabContainer.addEventListener('closing', (event) => {
        const tabs = tabContainer.getTabs();
        const closing = tabs[event.detail.index];

        // 'closing' is the only cancellable step: smart-tabs calls removeAt()
        // before firing 'close', so preventing it there is too late.
        if (closing && !this.isTabCloseable(closing)) {
          event.preventDefault();
          return;
        }

        closingTabs = tabs;
        _.map(closingTabs, (tab) => {
          if (tab.hasAttribute('selected')) {
            currentSelectedIndex = tab.getAttribute('index');
          }
        })
      })

      tabContainer.addEventListener('close', async (event) => {
        const closedIndex = event.detail.index;
        const id = closingTabs[closedIndex].getAttribute('id');

        this.handleTabClosed(tabContainer, closedIndex, id, currentSelectedIndex);
      })

      tabContainer.addEventListener('change', async (event) => {
        const index = event.detail.index;
        this.triggerTabSelected(tabContainer, index);
      })
    })
  },
};
